import { getSPDataWithParams, postSPDataWithoutParams } from './services'

export const AFFILIATION_BELONGS_TO_CLINIC = 'belongs-to-clinic'
export const AFFILIATION_BELONGS_TO_AUMHUM_NETWORK = 'belongs-to-aumhum-network'

export async function updateSupportClinicPractitionerAffiliation({
  clinicBrandId,
  clinicLocationId,
  mentorId,
  affiliationType,
}) {
  return postSPDataWithoutParams('/api/secure/cc/support/clinic/practitioner/affiliation/update', {
    clinicBrandId,
    clinicLocationId,
    mentorId,
    affiliationType,
  })
}

export async function getSupportClinicBrandBySlug(slug) {
  return getSPDataWithParams('/api/secure/cc/support/clinic-brand/get', { slug })
}
